import gql from 'graphql-tag'

const S3_SIGNED_UPLOAD_URL = gql`
  query {
    signedUploadUrl {
      url
      uuid
      __typename
    }
  }
`

export default S3_SIGNED_UPLOAD_URL



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideoUploader.query.js